import { ReservationQuestionDto } from "@/api/generated/generatedTypes";

export enum DinnerQuestionStep {
  LANGUAGE = "LANGUAGE",
  COST = "COST",
  DIETARY = "DIETARY",
  MESSAGE = "MESSAGE",
}

export const DINNER_QUESTION_STEP_ORDER = [
  DinnerQuestionStep.LANGUAGE,
  DinnerQuestionStep.COST,
  DinnerQuestionStep.DIETARY,
  DinnerQuestionStep.MESSAGE,
] as const;

// Map question slugs to step enums
export const getStepForQuestion = (question: ReservationQuestionDto): DinnerQuestionStep | null => {
  switch (question.slug) {
    case "preferredLanguage":
      return DinnerQuestionStep.LANGUAGE;
    case "preferredCost":
      return DinnerQuestionStep.COST;
    case "dietaryRestrictions":
      return DinnerQuestionStep.DIETARY;
    case "messageForGuests":
      return DinnerQuestionStep.MESSAGE;
    default:
      return null;
  }
};

// Get the question index for a given step
export const getQuestionIndexForStep = (
  step: DinnerQuestionStep,
  eventQuestions: ReservationQuestionDto[]
): number => {
  const targetSlug = (() => {
    switch (step) {
      case DinnerQuestionStep.LANGUAGE:
        return "preferredLanguage";
      case DinnerQuestionStep.COST:
        return "preferredCost";
      case DinnerQuestionStep.DIETARY:
        return "dietaryRestrictions";
      case DinnerQuestionStep.MESSAGE:
        return "messageForGuests";
    }
  })();

  return eventQuestions.findIndex((q) => q.slug === targetSlug);
};

// Get the step for a given question index
export const getStepForQuestionIndex = (
  index: number,
  eventQuestions: ReservationQuestionDto[]
): DinnerQuestionStep | null => {
  const question = eventQuestions[index];
  return question ? getStepForQuestion(question) : null;
};

// Get Korean label for step
export const getStepLabel = (step: DinnerQuestionStep): string => {
  switch (step) {
    case DinnerQuestionStep.LANGUAGE:
      return "언어";
    case DinnerQuestionStep.COST:
      return "예산";
    case DinnerQuestionStep.DIETARY:
      return "식이 제한";
    case DinnerQuestionStep.MESSAGE:
      return "메세지";
  }
};
